import { Component, ViewChild, ElementRef, OnInit, NgZone } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public debug:boolean = false;
  
  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;
  public questions:Array<any>;
  public currentVideo:string;
  public selected:number = -1;
  public askedQuestions: number[] = [];
  public loop:boolean;
  
  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;
  
  public isVP:any;
  private videoFolders:any;
  
  public current:string = 'loading';
  
  public debugTxt:string = '';
  
  public avatar:any;
  private videoSubscription:Subscription;
  
  public date:string;
  public time:string;
  private timeInterval:Subscription;
  
  private espaces:Array<any> = [
    {
      name: 'Végétale',
      color: '#fbab18'
    },
    {
      name: 'Animale',
      color: '#ee4991'
    },
    {
      name: 'Humaine',
      color: '#00aab0'
    },
    {
      name: 'Artificielle',
      color: '#ef4023'
    }
  ];
  public espace;
  
  public languages:Array<any> = [
    {
      'language': 'fr',
      'suffix': '',
      'local': 'fr-FR'
    },
    {
      'language': 'en',
      'suffix': '_en',
      'local': 'en-EN'
    }
  ];
  public lang:string;
  public suffix:string;
  public local:string;
  
  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;
  
  constructor(
    private service: MainService,
    private sanitizer:DomSanitizer,
    private titleService: Title,
    private ngZone: NgZone
  ) {
    this.log('constructor');
  }
  
  ngOnInit(){
    this.log('ngOnInit');
    this.base = AppConfig.datasServer;
    
    this.log('AppConfig', AppConfig, "*");
    
    this.datasName = this.findGetParameter('datas');
    this.log("this.datasName", this.datasName);
    
    // this.checkIfVP();
    this.loadDatas();
    
    window.addEventListener('idal-player-event', (e) => {
      if (e['detail'].type == 'folder-enter') {
        if (e['detail'].folder.number == 899){
          this.openVisio();
          // this.ngZone.run(() => {});
        }
      }
    });
    this.timeInterval = interval(1000).subscribe(() => {
      this.setTime();
    });
  }
  
  setDate():void
  {
    let event = new Date();
    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    this.date = event.toLocaleDateString(this.local, options);
  }
  setTime():void
  {
    let event = new Date();
    this.time = event.toLocaleTimeString(this.local);
  }
  
  checkIfVP(){
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }
  
  loadDatas(){
    
    this.current = 'loading';
    
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.log("datas.name", datas.name);
      this.datas = datas;
      
      this.espace = this.espaces.find((espace) => espace.name == this.datas.espace);
      this.titleService.setTitle( this.datas.name );
      
      this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
        this.videoFolders = datas;
        this.start();
      });
      
    }));
  }
  
  start(){
    this.avatar = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.image +')');
    timer(500).subscribe(() => {
      this.openVisio();
    });
  }
  
  openVisio(){
    this.current = 'visio';    
    this.selected = -1;
    delete this.currentVideo;
    this.playVideo({base: this.datas.video}, true);
    this.lang = this.languages[0].language;
    this.suffix = this.languages[0].suffix;
    this.local = this.languages[0].local;
  }
  
  findGetParameter(parameterName:string) {
    let result = null,
    tmp = [];
    let items = location.search.substr(1).split("&");
    for (let index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }
  onSplashClick(event) {
    if (!this.goodEvent(event)) return;
    this.openVisio();
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }
  }
  playVideo(folderBaseAndInc, loop){
    // this.current = 'video';
    let folder:string = folderBaseAndInc.base;
    
    console.log('folderBaseAndInc', folderBaseAndInc);
    
    let folderSplit = folder.split('*');
    if (folderSplit.length > 1){
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null){
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }
    
    if (this.isVP){
      this.playVideoExt(folder);
    } else {
      this.playVideoWeb(folder, loop);
    }
    this.log('current', this.current);
  }
  playVideoWeb(videoFolder:string, loop:boolean){
    this.loop = loop;
    
    
    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length){
      this.currentVideo = videoFolder+'/'+sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }
    
  }
  playVideoExt(videoFolder:string){
    this.currentVideo = videoFolder;
    
    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);
    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);
      
      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });
    
    // this.log("click", window['IDAL'].getControlInterfaces());
    // window['IDAL'].getControlInterfaces().then(function(ifaces) {
    //         // L'object ifaces contient toutes les interfaces de contrôle:
    //         //      - ifaces.player
    //         //      - ifaces.serial
    //         //      - ifaces.logger
    //         //      - ifaces.printer
    //         //      - ifaces.contact
    //
    //         // Il est maintenant par example possible de contrôler la lecture vidéo:
    //         ifaces.player.getAllFolders().then(function(folders) {
    //             // Faire quelque chose d'utile...
    //             this.log("Folders received: " + JSON.stringify(folders));
    //         }).catch(function(error) {
    //           this.log("ifaces.player.getAllFolders error");
    //           // Faire quelque chose d'utile...
    //         });
    // }).catch(function(error) {
    //   this.log("control interface error");
    //   // Faire quelque chose d'utile...
    // });
    
    // this.videoSubscription = interval(1000).subscribe(() => {
    //   this.videoUpdate();
    // });
  }
  
  getPoster(videoSrc){
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate(){
    if (this.videoTag && this.videoTag.nativeElement){
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }
  }
  onVideoEnded(e){
    if (!this.loop){
      if (this.videoSubscription){
        this.videoSubscription.unsubscribe();
        delete this.videoSubscription;
      }
      this.videoProgress = 0;
      this.current = 'visio';
      
      this.selected = -1;
      
      
      this.playVideo({base: this.datas.video}, true);
    }
  }
  onVideoClick(event){
    if (!this.goodEvent(event)) return;
    // this.current = 'splash';
  }
  onClick(event){
    if (!this.goodEvent(event)) return;
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      
      console.log(window.location.href);
      if (this.isVP){
        window.location.href = window.location+"index.html";
      } else {
        let tab = window.location.href.split('?');
        let url = tab[0];
        let get = '';
        if (tab[1]){
          get = '?'+tab[1];
        }
        if (url.slice(-1) != '/') {
          url += '/';
        }
        window.location.href = url+get;        
      }
      this.openVisio();
    });
  }
  
  onClickQuestion(event, num){
    if (!this.goodEvent(event)) return;
    this.selected = num;
    if (!this.askedQuestions.includes(num)) {
      this.askedQuestions.push(num);
    }
    this.playVideo({base: this.datas['questions'+this.suffix][num].video, inc: num}, false);
  }
  
  onHang(event){
    if (!this.goodEvent(event)) return;
    this.openVisio();
  }
  
  onLang(event:any, num:number):void
  {
    if (!this.goodEvent(event)) return;
    event.stopPropagation();
    this.lang = this.languages[num].language;
    this.suffix = this.languages[num].suffix;
    this.local = this.languages[num].local;
  }
  
  goodEvent(event){
    return (event.type == 'click') || (event.type == 'touchstart');
    // return (event.type == 'click' && !this.isVP) || (event.type == 'touchstart' && this.isVP);
  }
  
  log(...txts:any){
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
      this.debugTxt += '------';
      this.debugTxt += '<br>';
    } else {
      console.log(...txts);
    }
  }
  
  toStringLen(num:number, len:number):string
  {
    let ret = ''+num;
    while(ret.length < len){
      ret = '0'+ret;
    }
    return ret;
  }
  
}
